import { render, staticRenderFns } from "./FeedbackChip.vue?vue&type=template&id=51e18274"
import script from "./FeedbackChip.vue?vue&type=script&lang=js"
export * from "./FeedbackChip.vue?vue&type=script&lang=js"
import style0 from "./FeedbackChip.vue?vue&type=style&index=0&id=51e18274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports